import { PublicLegalShell } from "@/components/legal/PublicLegalShell";
import { LegalDocumentCard } from "@/components/legal/LegalDocumentCard";
import { LEGAL_DOCUMENTS } from "@/content/legal";

export default function PolitiqueConfidentialitePage() {
  return (
    <PublicLegalShell>
      <LegalDocumentCard doc={LEGAL_DOCUMENTS["politique-confidentialite"]} />
    </PublicLegalShell>
  );
}
